import HipHopApiClient from "../HipHopApiClient.js";

const HipHop = new HipHopApiClient({ 
    authToken: null, 
    endpoint: window.location.hostname === 'localhost' ? 
        'https://hiphop-smarco-seafront.vercel.app/api'
        : '/api',
});

export default HipHop;